<template>
  <div>
        <!-- 按钮区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-button type="primary" @click="openBatchAddDialog">
          批量入库
        </el-button>

        <el-switch
          v-model="showSupplierInfo"
          active-text="显示供应商信息"
          inactive-text="隐藏供应商信息"
          style="margin-left: 20px; "
        ></el-switch
      >
    </div>

    <!-- 多条件筛选区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
              <el-select
          v-model="searchCustomerId"
          filterable
          clearable
          placeholder="购买客户筛选"
        >
          <el-option
            v-for="item in customerList"
            :key="item.objectId"
            :label="item.name"
            :value="item.objectId"
          >
          </el-option>
        </el-select>

      <el-input
          v-model="searchPartName"
          placeholder="配件名称筛选"
           style="margin-left: 20px; width: 200px;"
          @keyup.enter.native="handleSearch" 
          clearable
        />

      <el-input
          v-model="searchCarModelCompatibility"
          placeholder="适用车型筛选"
          style="margin-left: 20px; width: 200px;"
          @keyup.enter.native="handleSearch"
          clearable
        />

        <el-select
          v-model="searchSupplierId"
          filterable
          clearable
          style="margin-left: 20px;"
          placeholder="供应商筛选"
        >
          <el-option
            v-for="item in supplierList"
            :key="item.objectId"
            :label="item.name"
            :value="item.objectId"
          >
          </el-option>
        </el-select>

        <el-button type="primary" @click="handleSearch" style="margin-left: 20px;"> 筛选 </el-button>
    </div>

    <!-- 批量新增弹窗 -->
    <el-dialog
      title="批量入库配件信息"
      :visible.sync="batchAddDialogVisible"
      width="1500px"
      :close-on-click-modal="false"
    >
      <!-- 动态表单 -->
      <el-form ref="form" :model="batchAddForm">
        <div
          v-for="(item, index) in batchAddForm.parts"
          :key="index"
          class="part-item"
        >
          <el-form-item label="购买客户" :prop="`parts.${index}.customerId`">
            <el-select
              filterable
              v-model="item.customerId"
              placeholder="选择购买客户"
              style="width: 150px"
            >
              <el-option
                v-for="s in customerList"
                :key="s.objectId"
                :label="s.name"
                :value="s.objectId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="配件名称" :prop="`parts.${index}.partName`">
            <el-input
              v-model="item.partName"
              placeholder="配件名称"
              style="width: 180px"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="适用车型"
            :prop="`parts.${index}.carModelCompatibility`"
          >
            <el-input
              v-model="item.carModelCompatibility"
              placeholder="适用车型"
              style="width: 180px"
            ></el-input>
          </el-form-item>

          <el-form-item label="单位" :prop="`parts.${index}.unit`">
            <el-input
              v-model="item.unit"
              placeholder="单位"
              style="width: 80px"
            ></el-input>
          </el-form-item>

          <el-form-item label="入库数量" :prop="`parts.${index}.stockQuantity`">
            <el-input
              v-model.number="item.stockQuantity"
              placeholder="入库数量"
              @input="(val) => (item.stockQuantity = val.replace(/[^\d]/g, ''))"
              style="width: 50px"
            ></el-input>
          </el-form-item>

          <el-form-item label="单价" :prop="`parts.${index}.unitPrice`">
            <el-input
              v-model.number="item.unitPrice"
              placeholder="单价"
              @input="
                (val) =>
                  (item.unitPrice = val
                    .replace(/[^\d.]/g, '')
                    .replace(/\.{2,}/g, '.')
                    .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
              "
              style="width: 80px"
            ></el-input>
          </el-form-item>

          <el-form-item label="售价" :prop="`parts.${index}.sellPrice`">
            <el-input
              v-model.number="item.sellPrice"
              placeholder="售价"
              @input="
                (val) =>
                  (item.sellPrice = val
                    .replace(/[^\d.]/g, '')
                    .replace(/\.{2,}/g, '.')
                    .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
              "
              style="width: 80px"
            ></el-input>
          </el-form-item>

          <el-form-item label="供应商" :prop="`parts.${index}.supplierId`">
            <el-select
              filterable
              v-model="item.supplierId"
              placeholder="选择供应商"
              style="width: 150px"
            >
              <el-option
                v-for="s in supplierList"
                :key="s.objectId"
                :label="s.name"
                :value="s.objectId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注" :prop="`parts.${index}.remark`">
            <el-input
              v-model="item.remark"
              placeholder="备注"
              style="width: 180px"
            ></el-input>
          </el-form-item>

          <el-form-item label="入库状态" :prop="`parts.${index}.isStore`">
            <el-select
              v-model="item.isStore"
              placeholder="是否入库"
              style="width: 80px"
            >
              <el-option
                v-for="s in storeList"
                :key="s.value"
                :label="s.label"
                :value="s.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-button
            v-if="index > 0"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="removeItem(index)"
          ></el-button>
        </div>
      </el-form>

      <div class="action-bar">
        <el-button @click="addItem" type="primary" icon="el-icon-plus">
          新增条目
        </el-button>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchAddDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="batchAddSubmitForm"
          :loading="batchAddSubmitting"
        >
          提交保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog
      title="编辑配件信息"
      :visible.sync="editDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" label-width="100px">
        <el-form-item label="购买客户" prop="customerId">
          <el-select
            filterable
            v-model="editForm.customerId"
            placeholder="选择购买客户"
            style="width: 460px"
          >
            <el-option
              v-for="s in customerList"
              :key="s.objectId"
              :label="s.name"
              :value="s.objectId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="配件名称" prop="partName">
          <el-input
            v-model="editForm.partName"
            placeholder="配件名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="适用车型" prop="carModelCompatibility">
          <el-input
            v-model="editForm.carModelCompatibility"
            placeholder="适用车型"
          ></el-input>
        </el-form-item>

        <el-form-item label="单位" prop="unit">
          <el-input v-model="editForm.unit" placeholder="单位"></el-input>
        </el-form-item>

        <el-form-item label="入库数量" prop="stockQuantity">
          <el-input
            v-model.number="editForm.stockQuantity"
            placeholder="入库数量"
            @input="
              (val) => (editForm.stockQuantity = val.replace(/[^\d]/g, ''))
            "
          ></el-input>
        </el-form-item>

        <el-form-item label="单价" prop="unitPrice">
          <el-input
            v-model.number="editForm.unitPrice"
            placeholder="单价"
            @input="
              (val) =>
                (editForm.unitPrice = val
                  .replace(/[^\d.]/g, '')
                  .replace(/\.{2,}/g, '.')
                  .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
            "
          ></el-input>
        </el-form-item>

        <el-form-item label="售价" prop="sellPrice">
          <el-input
            v-model.number="editForm.sellPrice"
            placeholder="单价"
            @input="
              (val) =>
                (editForm.sellPrice = val
                  .replace(/[^\d.]/g, '')
                  .replace(/\.{2,}/g, '.')
                  .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
            "
          ></el-input>
        </el-form-item>

        <el-form-item label="供应商" prop="supplierId">
          <el-select
            filterable
            v-model="editForm.supplierId"
            placeholder="选择供应商"
            style="width: 460px"
          >
            <el-option
              v-for="s in supplierList"
              :key="s.objectId"
              :label="s.name"
              :value="s.objectId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" placeholder="备注"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleEditSubmit"
          :loading="editSubmitting"
        >
          保 存
        </el-button>
      </span>
    </el-dialog>

    <!-- 表格 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px;" v-loading="loading">
      <!-- 类型字段转换列 -->
      <el-table-column
        prop="customerId"
        label="购买客户"
        width="150"
        :formatter="formatCustomerText"
      ></el-table-column>

      <el-table-column prop="partName" label="配件名称"></el-table-column>

      <el-table-column
        prop="carModelCompatibility"
        label="适用车型"
        width="170"
      ></el-table-column>

      <el-table-column prop="unit" label="单位" width="50"></el-table-column>

      <el-table-column
        prop="stockQuantity"
        label="数量"
        width="50"
      ></el-table-column>

      <el-table-column
        prop="unitPrice"
        label="进价"
        width="70"
        v-if="showSupplierInfo"
      ></el-table-column>

      <el-table-column
        prop="sellPrice"
        label="售价"
        width="70"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="supplierId"
        label="供货商"
        width="150"
        v-if="showSupplierInfo"
        :formatter="formatSupplierText"
      ></el-table-column>

      <el-table-column prop="remark" label="备注" width="180"></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="isStore"
        label="是否入库"
        width="50"
        :formatter="formatIsStoreText"
      ></el-table-column>

      <el-table-column
        prop="createdTime"
        label="入库时间"
        width="100"
      ></el-table-column>

      <el-table-column label="操作" width="200px">
        <template #default="{ row }">
          <el-button type="primary" size="mini" @click="openEditDialog(row)">
            编辑
          </el-button>

          <el-popconfirm
            title="确定这个配件已经收到了吗？"
            confirm-button-text="确定"
            cancel-button-text="取消"
            :disabled="!allowOperate(row)"
            @confirm="handleStoreConfirm(row)"
          >
            <template #reference>
              <el-button
                type="danger"
                size="mini"
                :disabled="!allowOperate(row)"
                style="margin-left: 20px"
                >确认入库</el-button
              >
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tableData: [], // 表格数据
      searchPartName: "",
      searchCarModelCompatibility: "",
      searchSupplierId: "",
      searchCustomerId: "",
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 总数据量
      loading: false, // 加载状态
      customerList: [],
      supplierList: [],
      customerMap: new Map(),
      supplierMap: new Map(),
      storeList: [
        { value: 0, label: "否" },
        { value: 1, label: "是" },
      ],
      storeMap: new Map([
        [0, "否"],
        [1, "是"],
      ]),
      showSupplierInfo: true,
      batchAddDialogVisible: false,
      batchAddSubmitting: false,
      batchAddForm: {
        parts: [this.emptyItem()],
      },
      editDialogVisible: false,
      editSubmitting: false,
      editForm: {
        objectId: "",
        partName: "",
        carModelCompatibility: "",
        unit: "",
        stockQuantity: "",
        supplierId: "",
        unitPrice: "",
        customerId: "",
        sellPrice: "",
        remark: "",
        orderNum: ""
      },
    };
  },

  created() {
    this.fetchData();
    this.fetchCustomerData();
    this.fetchSupplierData();
  },

  methods: {
    // 获取表格数据
    async fetchData() {
      try {
        this.loading = true;
        const params = {
          partName: this.searchPartName,
          carModelCompatibility: this.searchCarModelCompatibility,
          supplierId: this.searchSupplierId,
          customerId: this.searchCustomerId,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        };
        const response = await axios.post(
          "/api/AutomotivePart/getInventoryAccessoryList",
          params
        );

        this.tableData = response.data.result;
        this.total = response.data.total;
      } finally {
        this.loading = false;
      }
    },

    // 客户数据加载
    async fetchCustomerData() {
      try {
        const response = await axios.get(
          "/api/Customer/getAllCustomer"
        );

        this.customerList = response.data.result;

        this.customerMap = new Map();
        for (var item of response.data.result) {
          this.customerMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 供应商数据加载
    async fetchSupplierData() {
      try {
        const response = await axios.get(
          "/api/Supplier/getAllSupplier"
        );

        this.supplierList = response.data.result;

        this.supplierMap = new Map();
        for (var item of response.data.result) {
          this.supplierMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 格式化客户字段
    formatCustomerText(row) {
      return this.customerMap.get(row.customerId) || "未知客户";
    },

    // 格式化供应商字段
    formatSupplierText(row) {
      return this.supplierMap.get(row.supplierId) || "未知供应商";
    },

    // 格式化入库状态字段
    formatIsStoreText(row) {
      return this.storeMap.get(row.isStore) || "未知状态";
    },

    // 切换每页数量
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    // 切换页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    // 搜索
    handleSearch() {
      this.fetchData();
    },

    // 打开批量新增弹窗
    openBatchAddDialog() {
      this.batchAddDialogVisible = true;
      this.batchAddForm.parts = [this.emptyItem()];
    },

    // 行数据初始化
    emptyItem() {
      return {
        objectId: "",
        partName: "",
        carModelCompatibility: "",
        unit: "",
        unitPrice: 0,
        sellPrice: 0,
        stockQuantity: 1,
        supplierId: "",
        customerId: "",
        isStore: 0,
        remark: "",
        orderNum: 0
      };
    },

    // 插入条目
    addItem() {
      var newItem = this.emptyItem();

      if (this.batchAddForm.parts.length > 0) {
        newItem.customerId =
          this.batchAddForm.parts[
            this.batchAddForm.parts.length - 1
          ].customerId;
        newItem.carModelCompatibility =
          this.batchAddForm.parts[
            this.batchAddForm.parts.length - 1
          ].carModelCompatibility;
      }

      this.batchAddForm.parts.push(newItem);
    },

    // 移除条目
    removeItem(index) {
      this.batchAddForm.parts.splice(index, 1);
    },

    // 批量新增
    async batchAddSubmitForm() {
      try {
        this.batchAddSubmitting = true;

        // 调用批量新增接口
        var response = await axios.post(
          "/api/AutomotivePart/batchAddAutomotiveParts",
          this.batchAddForm.parts
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("批量新增成功");

          await this.fetchData();

          this.batchAddDialogVisible = false;
        } else {
          this.$message.error(`批量新增失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("提交失败:", error);
        this.$message.error(error.response?.data?.message || "提交失败");
      } finally {
        this.batchAddSubmitting = false;
      }
    },

    // 打开编辑弹窗
    openEditDialog(row) {
      this.editForm = {
        ...row,
      };
      this.editDialogVisible = true;
    },

    // 提交修改
    async handleEditSubmit() {
      try {
        this.editSubmitting = true;

        // 调用更新接口
        var response = await axios.post(
          "/api/AutomotivePart/editAutomotiveParts",
          this.editForm
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("更新成功");

          await this.fetchData();

          this.editDialogVisible = false;
        } else {
          this.$message.error(`更新失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      } finally {
        this.editSubmitting = false;
      }
    },

    // 是否允许操作
    allowOperate(row) {
      return row.isStore == 0;
    },

    // 入库确认
    async handleStoreConfirm(row) {
      try {
        // 调用更新接口
        var response = await axios.post(
          "/api/AutomotivePart/EditStoreStatus",
          [row.objectId]
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("入库成功");

          await this.fetchData();
        } else {
          this.$message.error(`更新失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      }
    },
  },
};
</script>

<style scoped>
.filter-section {
  margin-bottom: 20px;
}

.el-col {
  margin-bottom: 10px;
}

.error-alert {
  margin-bottom: 20px;
}

.part-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.part-item >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.action-bar {
  text-align: center;
  margin-top: 20px;
}
</style>
